import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type ReimaginedDataService from 'tio-employee/services/reimagined-data';

export default class PslfIndexRoute extends Route {
  @service declare reimaginedData: ReimaginedDataService;

  async model() {
    const pslfData = await this.reimaginedData.fetchPslfData();
    console.log('[PSLF Demo] scenario data:', pslfData);
    return { pslfData };
  }
}
